import { IntlProvider } from 'react-intl';
import { ComponentConfigProvider } from '@cbhq/cds-web/system/ComponentConfigProvider';
import type { GraphqlEnvironment } from '@cbhq/data-layer';
import { GraphqlProvider } from '@cbhq/data-layer';
import { legacyInputLabelConfig } from '@cbhq/identity-shared/web';
import { FetchableResourceProvider } from '@cbhq/instant-api-hooks-core/fetch';

import { InitialLoaderProvider } from './contexts/InitialLoaderProvider';
import { UserProfileProvider } from './contexts/UserProfileProvider';
import { SessionProvider } from './providers/SessionProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { BrowserRouter } from './routing/BrowserRouter';
import { ExperimentsProvider } from './utils/experiments';
import { apiFetch } from './utils/fetch';
import { history } from './utils/history';

type Props = {
  children: React.ReactNode;
  locale: string;
  messages?: Record<string, string>;
  environment: GraphqlEnvironment;
};

export function AppProviders({ children, locale, messages, environment }: Props) {
  return (
    <IntlProvider locale={locale} defaultLocale="en" messages={messages}>
      <SessionProvider>
        <GraphqlProvider environment={environment}>
          <FetchableResourceProvider fetch={apiFetch}>
            <ComponentConfigProvider value={legacyInputLabelConfig}>
              <ThemeProvider>
                <InitialLoaderProvider>
                  <UserProfileProvider>
                    <ExperimentsProvider>
                      <BrowserRouter history={history}>{children}</BrowserRouter>
                    </ExperimentsProvider>
                  </UserProfileProvider>
                </InitialLoaderProvider>
              </ThemeProvider>
            </ComponentConfigProvider>
          </FetchableResourceProvider>
        </GraphqlProvider>
      </SessionProvider>
    </IntlProvider>
  );
}
